// TODO: Implement form field enum, check if its implemented on other assessments
import { BackgroundFormField } from './subsections/background/formField'
import { TherapiesFormField } from './subsections/therapies/formField'
import { HistoryFormField } from './subsections/history/formField'
import { ImmunizationsFormField } from './subsections/immunizations/formField'
import { RiskAssessmentFormField } from './subsections/risk-assessment/formField'
import { NeurologicalFormField } from './subsections/neurological/formField'
import { CognitivePsychosocialFormField } from './subsections/cognitive-psychosocial/formField'
import { MusculoskeletalFormField } from './subsections/musculoskeletal/formField'
import { LinesDrainsFormField } from './subsections/lines-drains/formField'
import { SensoryFormField } from './subsections/sensory/formField'
import { PainFormField } from './subsections/pain/formField'
import { CardiacFormField } from './subsections/cardiac/formField'
import { RespiratoryFormField } from './subsections/respiratory/formField'
import { EndocrineFormField } from './subsections/endocrine/formField'
import { GastrointestinalFormField } from './subsections/gastrointestinal/formField'
import { IntegumentaryFormField } from './subsections/integumentary/formField'
import { PhysicianNotificationFormField } from './subsections/physician-notification/formField'
import { CareCoordinationFormField } from './subsections/care-coordination/formField'

export const MedicalBackgroundFormField = {
  ...BackgroundFormField,
  ...TherapiesFormField,
  ...HistoryFormField,
  ...ImmunizationsFormField,
  ...RiskAssessmentFormField,
  ...NeurologicalFormField,
  ...CognitivePsychosocialFormField,
  ...MusculoskeletalFormField,
  ...LinesDrainsFormField,
  ...SensoryFormField,
  ...PainFormField,
  ...CardiacFormField,
  ...RespiratoryFormField,
  ...EndocrineFormField,
  ...GastrointestinalFormField,
  ...IntegumentaryFormField,
  ...PhysicianNotificationFormField,
  ...CareCoordinationFormField,
  MEDICAL_BACKGROUND_INITIALS_AUTHORIZATION: 'medical-background/initials-authorization'
} as const

export type MedicalBackgroundFormField =
  (typeof MedicalBackgroundFormField)[keyof typeof MedicalBackgroundFormField]
